<template>
  <div class="leaderboard">
    <div class="leaderboard__item" v-for="item in props.leaderboard" :key="item.place" :class="{current: item.userId === store.getters.getUser.id}">
      <div class="info">
        <div class="place">{{item.place}}</div>
        <div class="userinfo">
          <div class="icon">
            <img v-if="item.userAvatarUrl" :src="item.userAvatarUrl">
          </div>
          <div class="userinfo__content">
            <div class="username">{{ item.userLabel }}</div>
            <div class="reward">
              <img src="/img/coins/gold_coin.svg">
              <span>{{numberFormatter.formatNumber(item.prize)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="scores" v-if="props.tournament.type === TournamentType.POKER">
        <span class="text-capitalize-first label">{{ $t(`poker_combinations.${item.pokerCombination?.combination ?? 'NONE'}`) }}</span>
        <PokerCombination :pokerCombination="item.pokerCombination"/>
      </div>
      <div class="scores" v-else>
        <span class="text-capitalize-first label">{{$t('score')}}</span>
        <span class="score">{{numberFormatter.formatNumber(item.points)}}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useStore} from "vuex";
import {numberFormatter} from "@/service/NumberFormatter";
import {TournamentType} from "@/models/enum/TournamentType";
import TournamentDTO from "@/models/TournamentDTO";
import TournamentParticipantDTO from "@/models/TournamentParticipantDTO";
import PokerCombination from "@/components/PokerCombination.vue";

const props = defineProps<{
  leaderboard: TournamentParticipantDTO[]
  tournament: TournamentDTO
}>()

const store = useStore()
</script>